import { FC } from 'react';
import { twMerge } from 'tailwind-merge';
import { UserCard } from '../../UserCard/UserCard';
import { PinButton, SidebarBase, SidebarUtilityNav } from '../common';
import { DefaultSidebarLogo } from './DefaultSidebarLogo';
import { SidebarNavigation } from './SidebarNavigation';

export const Sidebar: FC = () => {
  return (
    <SidebarBase>
      {({ onPinClick, pinButtonRef }) => (
        <div className='flex min-h-0 flex-1 flex-col gap-4 group-data-[expanded=false]/sidebar:gap-2'>
          <div className='flex shrink-0 justify-between items-center group-data-[expanded=false]/sidebar:flex-col'>
            <DefaultSidebarLogo
              titleClassName={twMerge(
                'hidden h-full shrink-0',
                'transition-discrete starting:opacity-0 motion-safe:delay-200 motion-safe:duration-500 ',
                'group-data-[expanded=true]/sidebar:block'
              )}
            />
            <PinButton ref={pinButtonRef} onClick={onPinClick} classNames={{}} />
          </div>
          <div className='min-h-0 flex-1 overflow-y-auto overscroll-contain'>
            <SidebarNavigation />
          </div>
          <SidebarUtilityNav />
          <UserCard />
        </div>
      )}
    </SidebarBase>
  );
};
